import { ProductCode } from '../shared/enums/smarthub-enums';

export class Product {
  id: number;
  amount: number;
  productCode: ProductCode;
  i18nkey: string;

  constructor(id: number, product: ProductCode, i18nkey: string) {
    this.id = id;
    this.productCode = product;
    this.i18nkey = i18nkey;
  }
}

export class Products {
  static EmployeePay = new Product(1, ProductCode.EmployeePay, 'COMMON.EMPLOYEE_PAY');
  static Taxes = new Product(2, ProductCode.Tax, 'COMMON.TAXES');
  static Garnishments = new Product(3, ProductCode.Garnishments, 'COMMON.GARNISHMENTS');

  static all(): Product[] {
    return [ this.EmployeePay, this.Taxes, this.Garnishments ];
  }
}
